<template>
    <div
        id="bitmapdetailform"
        class="container-fluid"
        v-bind:class="{ 'modal-toppadding': displayedInModal }"
    >
        <h1 class="text-left">{{ title }}</h1>
        <br />
        <b-form
            ref="bitmapform"
            name="organizationBitmapForm"
            v-on:submit.prevent="$_onSubmit"
            class="pb-5"
        >
            <div id="orgLogoContainer">
                <div
                    :class="displayedInModal === true ? 'col-md-3' : 'col-md-2'"
                >
                    <!--Bitmaps-->
                    <base-select
                        :name="'logoTypeSelect'"
                        :text="$t('columnTypeTitle')"
                        :value="getimagetype"
                        :options="availableLogoTypes"
                        :extendedClass="{
                            plaintext:
                                mode === modeEditConst || displayedInModal
                        }"
                        :disabled="mode === modeEditConst || displayedInModal"
                        required
                        @selected="$_onImageTypeSelected"
                    >
                    </base-select>
                </div>
                <div class="padding_left_small">
                    <info-button :name="'btn-bitmap-info'" />
                    <tooltip
                        :target="'btn-bitmap-info'"
                        :title="$t('uploadImageInfoMaxSize')"
                        :customClass="'large'"
                    >
                    </tooltip>
                    <image-loader
                        id="organizationLogoLoader"
                        name="organizationLogoLoader"
                        :maxFileSize="maxImageSize"
                        :value="logo.imageData"
                        maxFileSizeErrorMessage="100kb"
                        imgExtendedClass="logo-box-size"
                        @metadata="$_onMetadata"
                        :required="
                            selectedUrlBitmap === null &&
                            logo.imageData === null
                        "
                        @input="$_onSelectedImage"
                    >
                    </image-loader>
                </div>
            </div>
            <!-- Save/cancel/remove buttons -->
            <SubmitCancelRemove
                :is-saving="isSaving"
                :is-deleting="isDeleting"
                :mode="editMode ? modeEditConst : modeAddConst"
                :class="{ 'modal-position': displayedInModal }"
                @cancel="$_onCancel"
                @remove="$_onRemove"
            >
            </SubmitCancelRemove>
        </b-form>
    </div>
</template>

<script>
    import { convertToValueTextPair } from '../../services/utilities';
    import { AVAILABLE_LOGO_TYPE, MODE_ADD, MODE_EDIT } from '../../constants';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import BaseSelect from '../../components/BaseComponents/base-select.vue';
    import ImageLoader from '../../components/ImageLoader.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';
    import InfoButton from '../../components/InfoButton.vue';
    import Tooltip from '../../components/Tooltip.vue';

    export default {
        mixins: [modalMixin],

        components: {
            'base-select': BaseSelect,
            'image-loader': ImageLoader,
            'info-button': InfoButton,
            tooltip: Tooltip,
            SubmitCancelRemove
        },

        props: {
            id: { type: Number, default: -1 },
            metadata: { type: Object, default: null },
            displayedInModal: { type: Boolean, default: false },
            selectedImageType: { type: Number, default: -1 },
            organizationId: { type: Number, default: -1 }
        },

        data() {
            return {
                // Constants
                availableLogoTypeConst: AVAILABLE_LOGO_TYPE,
                modeAddConst: MODE_ADD,
                modeEditConst: MODE_EDIT,

                userInfo: {},
                mode: 0,
                title: '',
                isSaving: false,
                isDeleting: false,
                // max size 100kb
                maxImageSize: 0.1 * 1024 * 1024,
                orgImage: null,
                logo: {
                    id: 0,
                    name: '',
                    organizationId:
                        this.organizationId > 0
                            ? this.organizationId
                            : this.$store.getters.userInfo.organizationId,
                    imageData: null,
                    imageType: null
                },
                buttonBitmapsOptions: [],
                buttonBitmaps: [],
                selectedUrlBitmap: null,
                organizationHasNorthArrow: false
            };
        },

        created() {
            this.userInfo = this.$store.getters.userInfo;
            if (this.id > 0) {
                this.mode = MODE_EDIT;
                this.title = this.$t('bitmapDetailEditTitle');
            } else {
                this.mode = MODE_ADD;
                this.title = this.$t('bitmapDetailAddTitle');
            }
            if (this.displayedInModal && this.selectedImageType > 0) {
                this.logo.imageType = this.selectedImageType;
            }
        },

        computed: {
            editMode() {
                return this.mode === MODE_EDIT;
            },

            getimagetype() {
                return this.logo.imageType ? this.logo.imageType.toString() : null;
            },

            selectedUrlBitmapValue() {
                return this.selectedUrlBitmap ? this.selectedUrlBitmap.id : null;
            },
            availableLogoTypes() {
                // Northarrow is only available when the organization does not have an northarrow
                let logoTypes = [...this.availableLogoTypeConst];
                if (this.organizationHasNorthArrow) {
                    logoTypes = logoTypes.filter((a) => a.value != 4);
                }
                return logoTypes;
            }
        },

        mounted() {
            if (this.metadata) {
                this.logo = this.metadata;
            }
            if (this.id > 0 && this.metadata === null) {
                this.$_getOrganizationLogo(this.id);
            }
            if (this.metadata === null && this.id < 0) {
                this.$_getOrganizationUrlBitmaps();
            }
        },

        methods: {
            /*
             * Converts the image data from base64 to string representation
             */
            $_convertData() {
                // Convert image in case of string representaion
                if (this.logo.imageData.startsWith('data:')) {
                    this.logo.imageData = Buffer.from(this.logo.imageData).toString(
                        'base64'
                    );
                }
            },

            /*
             * Deletes the selected bitmap
             */
            async $_deleteBitmap() {
                const deleteConfirm = {
                    message: this.$t('imageDeleteConfirmation', [
                        `${AVAILABLE_LOGO_TYPE[this.logo.imageType - 1].text}`
                    ])
                };

                this.msgBoxConfirm(deleteConfirm).then(async (confirm) => {
                    if (confirm) {
                        try {
                            this.isDeleting = true;
                            const result = await this.$store.dispatch(
                                'useApiData',
                                {
                                    name: 'DeleteLogo',
                                    parameters: { id: this.logo.id }
                                }
                            );
                            if (result?.data) {
                                this.$_gotoOverview();
                            } else {
                                this.msgBoxOk({
                                    message: this.$t('imageInUse', [
                                        `${
                                            AVAILABLE_LOGO_TYPE[
                                                this.logo.imageType - 1
                                            ].text
                                        }`
                                    ])
                                });
                                this.isDeleting = false;
                            }
                        } catch (error) {
                            const data = {
                                message: this.$t('deleteFailureMessage', [
                                    `${error.message}`
                                ]),
                                variant: 'danger',
                                title: this.$t('deleteFailureTitle'),
                                autoHideDelay: 10000
                            };
                            this.showToast(data);
                            this.isDeleting = false;
                        }
                    }
                });
            },

            $_getImageTypeText() {
                let imageTypeText = '';
                if (this.logo.imageType) {
                    if (parseInt(this.logo.imageType, 10) === 1) {
                        imageTypeText = 'logo';
                    } else if (parseInt(this.logo.imageType, 10) === 2) {
                        imageTypeText = 'favicon';
                    }
                }
                return imageTypeText;
            },

            /**
             * Gets the logo with given id
             * @param id
             */
            async $_getOrganizationLogo(id) {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetOrganizationLogoByLogoId',
                    parameters: { logoId: id }
                });
                if (result?.data) {
                    this.logo = result.data;
                    this.logo.imageData = Buffer.from(
                        this.logo.imageData,
                        'base64'
                    ).toString();
                }
            },

            async $_getOrganizationUrlBitmaps() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetOrganizationLogos',
                    parameters: {
                        id: this.$store.getters.userInfo.organizationId
                    }
                });
                if (result?.data) {
                    this.buttonBitmapsOptions = result.data.filter(
                        (item) => item.imageType === AVAILABLE_LOGO_TYPE[2].value
                    );
                    this.buttonBitmaps = convertToValueTextPair(
                        this.buttonBitmapsOptions,
                        'id',
                        'name'
                    );
                    this.organizationHasNorthArrow = result.data.some(
                        (item) => item.imageType === AVAILABLE_LOGO_TYPE[3].value
                    );
                }
            },

            /*
             * Navigates back to overview
             */
            $_gotoOverview() {
                this.$router.push('/dashboard/bitmaps');
            },

            /**
             * Sets the selected image data
             * @param value
             */
            $_onSelectedImage(value) {
                this.logo.imageData = value;
                if (value && this.selectedUrlBitmap !== null) {
                    this.selectedUrlBitmap = null;
                }
            },

            /**
             * Sets the selected type
             * @param type
             */
            $_onImageTypeSelected(type) {
                this.logo.imageType = type;
            },

            $_onCancel() {
                // Don't navigate to overview when domain is add by modal
                if (this.displayedInModal) {
                    this.$emit('add-bitmap-cancel');
                } else {
                    this.$_gotoOverview();
                }
            },

            $_onUrlBitmapSelected(input) {
                this.logo.imageData = null;
                this.selectedUrlBitmap = this.buttonBitmapsOptions.find(
                    (item) => item.id === input
                );
            },

            /**
             * Assigns the metadata from router to logo object
             * @param metadata
             */
            $_onMetadata(metadata) {
                this.logo.name = metadata.fileName;
            },

            /*
             * Removes the bitmap/image
             */
            async $_onRemove() {
                if (!this.userInfo.isSuper && !this.userInfo.isAdmin) {
                    this.msgBoxOk({
                        message: this.$t('notAllowedToDeleteMessage')
                    });
                    return;
                }

                const result = await this.$store.dispatch('useApiData', {
                    name: 'IsBitmapInUse',
                    parameters: {
                        orgId: this.userInfo.organizationId,
                        bitmapId: this.logo.id
                    }
                });
                if (result?.data) {
                    this.msgBoxOk({
                        message: this.$t('imageDeleteInUserConfirmation', [
                            this.$_getImageTypeText()
                        ])
                    });
                } else {
                    this.$_deleteBitmap();
                }
            },

            /*
             * Saves the bitmap/image
             */
            $_onSubmit() {
                if (this.$refs.bitmapform.checkValidity()) {
                    if (this.selectedUrlBitmap === null) {
                        // Set image type
                        if (
                            this.displayedInModal &&
                            this.selectedImageType === AVAILABLE_LOGO_TYPE[2].value
                        ) {
                            this.logo.imageType = this.selectedImageType;
                        }
                        this.$_save();
                    } else {
                        // An existing bitmap is chosen, emit the value to the subscriber
                        this.$emit('add-bitmap-saved', this.selectedUrlBitmap);
                    }
                }
            },

            async $_save() {
                if (
                    this.logo.imageType &&
                    this.logo.imageType > 0 &&
                    this.logo.imageData !== null
                ) {
                    this.$_convertData();
                    this.isSaving = true;
                    await this.$store
                        .dispatch('useApiData', {
                            name: 'SaveOrganizationLogo',
                            data: this.logo
                        })
                        .then((result) => {
                            if (result.data) {
                                if (this.displayedInModal) {
                                    this.$emit('add-bitmap-saved', result.data);
                                } else if (!this.editMode) {
                                    this.$_gotoOverview();
                                } else {
                                    const data = {
                                        message: this.$t('imageSavedConfirmation'),
                                        variant: 'success',
                                        autoHideDelay: 2500,
                                        noCloseButton: true
                                    };
                                    this.showToast(data);
                                }
                            }
                            this.isSaving = false;
                        })
                        .catch((error) => {
                            const data = {
                                message: error.message,
                                variant: 'danger',
                                title: this.$t('imageSaveFailedError'),
                                autoHideDelay: 5000
                            };
                            this.showToast(data);
                            this.isSaving = false;
                        });
                }
            }
        }
    };
</script>

<style>
.logo-box-size {
    max-height: 400px;
}
</style>
<style scoped>
.modal-toppadding {
    padding-top: 0 !important;
}
</style>
